import {CancellationBannerState} from '../types/cancellationBanner.types'
import {CancellationRequestStatus} from '../types/cancellationRequest.types'

import {normalizeCancellationRequestStatus} from './normalizeCancellationRequestStatus'

const NO_BANNER: CancellationBannerState = {showBanner: false, variant: null}

export const determineCancellationBannerState = (
  request: CancellationRequestStatus | null | undefined,
  orderStatus?: string,
  dismissedRequestIds: string[] = []
): CancellationBannerState => {
  if (!request || dismissedRequestIds.includes(request.requestId)) return NO_BANNER

  const status = normalizeCancellationRequestStatus(request.status)

  if (status === 'sent') {
    return {showBanner: true, variant: 'cancellationProcessing'}
  }

  if (status === 'failed') {
    return {showBanner: true, variant: 'cancellationFailed'}
  }

  if (status === 'completed' && orderStatus?.toLowerCase() !== 'cancelled') {
    return {showBanner: true, variant: 'cancellationCompleted'}
  }

  return NO_BANNER
}
